import type { BannerProps } from './types';

// The page around the filters (layouts/application). The server renders it in the initial
// layout; CasinoFilters follows the changes here.
export type PageLayout = {
  // A search is on: the filters take the search look and the banner folds.
  searching: boolean;
  // The visitor's own choice, remembered in the banner's cookie.
  bannerHidden: boolean;
};

const YEAR = 60 * 60 * 24 * 365; // s

const bannerFolded = ({ searching, bannerHidden }: PageLayout) => searching || bannerHidden;

export const applyPageLayout = (layout: PageLayout, previous: PageLayout): void => {
  const content = document.querySelector('.content_right');
  // _filters.scss and _banner.scss.
  content?.classList.toggle('search-mode', layout.searching);
  content?.classList.toggle('banner-hidden', layout.bannerHidden);
  // Animates the swap of the toggle and the reset - after a visitor's action, not on page load.
  content?.classList.add('layout-changed');

  const folded = bannerFolded(layout);
  document.querySelector('[data-banner]')?.toggleAttribute('inert', folded);
  if (folded !== bannerFolded(previous)) {
    // Lets the banner's content (e.g. a carousel) pause.
    document.dispatchEvent(new CustomEvent('xo:banner-visibility', { detail: { hidden: folded } }));
  }
};

// A hidden banner stays hidden while the banners' version is the same.
export const rememberBannerHidden = (hidden: boolean, { version, cookie }: BannerProps): void => {
  document.cookie = hidden
    ? `${cookie}=${version}; path=/; max-age=${YEAR}; samesite=lax`
    : `${cookie}=; path=/; max-age=0; samesite=lax`;
};

// The sidebar's filter links (BrandXo::ApplicationHelper#sidebar_filter, sidebar.js).
export const clearSidebarSelection = (): void => {
  document.querySelectorAll('[data-sidebar-list].selected').forEach((el) => el.classList.remove('selected'));
};
